import { render, staticRenderFns } from "./ChangeAdminStatusModal.vue?vue&type=template&id=363a4976&scoped=true"
import script from "./ChangeAdminStatusModal.vue?vue&type=script&lang=js"
export * from "./ChangeAdminStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a4976",
  null
  
)

export default component.exports